module.exports = __webpack_public_path__ + "img/bike.d9553ce0.svg";